import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import useListService from '@/data/hook/useListService';
import { studentDashboardQueries } from '@/data/query-keys/studentDashboardQueryKey';
import { StudentDashboardFilters } from '@/data/services/studentDashboardStatsServices';
import StudentDashboardStats from '@/models/StudentDashboard';

export type UseActiveCourseProgressParams = {
  courseProgresses: StudentDashboardStats[];
  hasNextPage: boolean;
  filters: StudentDashboardFilters;
  slug?: string;
  fallbackToFirst: boolean;
};

export default function useActiveCourseProgress({
  courseProgresses,
  hasNextPage,
  filters,
  slug,
  fallbackToFirst,
}: UseActiveCourseProgressParams) {
  const listedCourseProgress = courseProgresses.find(
    ({ coursePath }) => coursePath.slug === slug,
  );

  const { results, isInitialLoading } = useListService({
    ...studentDashboardQueries.courseProgresses({
      ...filters,
      coursePathSlug: slug,
    }),
    enabled: hasNextPage && !listedCourseProgress && !!slug,
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });

  const firstCourseProgress = fallbackToFirst ? courseProgresses[0] : undefined;

  return {
    activeCourseProgress:
      listedCourseProgress ??
      results[0] ??
      (isInitialLoading ? undefined : firstCourseProgress),
    isLoading: isInitialLoading,
  };
}
